import { T } from '@transifex/react';
import { useUserImpersonation } from '../../../context/UserImpersonationContext';
import { Button, InfoBar } from '@wfp/ui';
import './UserImpersonationControlBar.scss';

export const UserImpersonationControlBar = () => {
  const { isImpersonating, stopImpersonating, impersonatedUserEmail } =
    useUserImpersonation();

  return isImpersonating ? (
    <InfoBar className="impersonation-control-bar" pageWidth="lg">
      <T
        _str="You are currently impersonating {email}"
        email={impersonatedUserEmail}
      />
      <Button small kind="tertiary" onClick={stopImpersonating}>
        <T _str="Stop" />
      </Button>
    </InfoBar>
  ) : null;
};
